export function getUtf8Bytes(str) {
  const utf8 = []

  for (let idx = 0; idx < str.length; idx++) {
    let charcode = str.charCodeAt(idx)

    if (charcode < 0x80) {
      utf8.push(charcode)
    } else if (charcode < 0x800) {
      utf8.push(
        0xc0 | (charcode >> 6),
        0x80 | (charcode & 0x3f)
      )
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      utf8.push(
        0xe0 | (charcode >> 12),
        0x80 | ((charcode >> 6) & 0x3f),
        0x80 | (charcode & 0x3f)
      )
    } else {
      idx++
      // UTF-16 encodes 0x10000-0x10FFFF by
      // subtracting 0x10000 and splitting the
      // 20 bits of 0x0-0xFFFFF into two halves
      charcode = 0x10000 + (
        ((charcode & 0x3ff) << 10) |
        (str.charCodeAt(idx) & 0x3ff)
      )
      utf8.push(
        0xf0 | (charcode >> 18),
        0x80 | ((charcode >> 12) & 0x3f),
        0x80 | ((charcode >> 6) & 0x3f),
        0x80 | (charcode & 0x3f)
      )
    }
  }

  return utf8
}

export function doubleEncodeUtf8(str) {
  const utf8Bytes = getUtf8Bytes(str)
  return arrayBufferToBinaryString(utf8Bytes)
}

export function arrayBufferToBinaryString(arrayBuffer) {
  const bytes = new Uint8Array(arrayBuffer)
  let bin = ''

  for (let idx = 0; idx < bytes.byteLength; idx++) {
    bin += String.fromCharCode(bytes[idx])
  }

  return bin
}

export function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64)
  const binaryLen = binaryString.length
  const bytes = new Uint8Array(binaryLen)
  for (var i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i)
    bytes[i] = ascii
  }
  return bytes
}
